import { useEffect } from 'react';
import classNames from 'classnames/bind';
import { useSelector } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';

import GameIcon from '~/components/GameIcon';
import styles from './ConfirmPayment.module.scss';
import FormPayment from '~/components/FormPayment';

const cx = classNames.bind(styles);

function ConfirmPayment() {
    const navigate = useNavigate();
    const { paymentSelected } = useSelector((state) => state.payment);

    useEffect(() => {
        if (!isMobile) {
            navigate('/app');
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={cx('wrapper')}>
            <GameIcon title={paymentSelected?.title} />

            <FormPayment />
        </div>
    );
}

export default ConfirmPayment;
